import { createContext } from "react";

interface DeviceFormat {
    isDesktopOrLaptop: boolean;
};

export const MediaQueryContext = createContext<DeviceFormat>({
    isDesktopOrLaptop: false
});